import AuthActionTypes from './auth.types';

const initialState = {
  loading: false,
  location: null,
  user: {},
  tenant: {},
  token: null,
  toast: {
    show: false,
    message: '',
  },
  userRole: '',
};

const showToast = (state, action) => {
  const { show, message, type } = action.payload;
  return { ...state, toast: { show: show, message: message, type } };
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.SET_TOKEN:
      return { ...state, token: action.payload };
    case AuthActionTypes.SET_USER_DATA:
      return { ...state, user: action.payload };
    case AuthActionTypes.SET_USER_ROLE:
      return { ...state, userRole: action.payload };
    case AuthActionTypes.REMOVE_TOKEN:
      return { ...state, token: null };
    case AuthActionTypes.REMOVE_USER_DATA:
      return { ...state, user: {} };
    case AuthActionTypes.SHOW_TOAST:
      return showToast(state, action);
    case AuthActionTypes.SET_LOCATION:
      return { ...state, location: action.payload };
    case AuthActionTypes.SET_TENANT:
      return { ...state, tenant: action.payload };
    default:
      return state;
  }
};

export default authReducer;
